import { render, staticRenderFns } from "./RoteirizacaoMapLegend.vue?vue&type=template&id=451a6b9e&scoped=true&"
import script from "./RoteirizacaoMapLegend.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoMapLegend.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoMapLegend.vue?vue&type=style&index=0&id=451a6b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a6b9e",
  null
  
)

export default component.exports